<input
  type="text"
  class="form-control"
  [class.is-invalid]="invalid"
  [disabled]="disabled"
  [value]="value"
  (change)="updateValue($event)"
  (keyup)="keyUp.emit($event)"
/>
<app-parameter-form-control-validation-errors [errors]="errors"></app-parameter-form-control-validation-errors>
